/* Designer Plants mobile-first PDP image viewer. The lower gallery stays compact; the lightbox shows one image at a time and hydrates only the current/adjacent images as the customer browses. */
(function(){
  'use strict';
  if(window.dpSecondaryGalleryBound)return;
  window.dpSecondaryGalleryBound=true;

  function toArray(list){return Array.prototype.slice.call(list||[]);}
  function clean(value){return String(value||'').replace(/\s+/g,' ').trim();}
  function clamp(value,min,max){return Math.max(min,Math.min(max,value));}

  function imageRecord(img){
    return {
      src:img.getAttribute('src')||'',
      srcset:img.getAttribute('srcset')||'',
      alt:clean(img.getAttribute('alt')),
      width:parseInt(img.getAttribute('width')||img.naturalWidth||0,10),
      height:parseInt(img.getAttribute('height')||img.naturalHeight||0,10)
    };
  }

  function makeImage(record,sizes,eager){
    var img=document.createElement('img');
    img.alt=record.alt||'';
    img.decoding='async';
    img.draggable=false;
    img.loading=eager?'eager':'lazy';
    if(!eager)img.setAttribute('fetchpriority','low');
    if(sizes)img.setAttribute('sizes',eager?sizes:'auto, '+sizes);
    if(record.srcset)img.setAttribute('srcset',record.srcset);
    if(record.width>0)img.width=record.width;
    if(record.height>0)img.height=record.height;
    img.src=record.src;
    return img;
  }

  function init(root){
    if(!root||root.dataset.dpSecondaryGalleryReady==='1')return;

    var sourceImages=toArray(root.querySelectorAll('.dp-u__stage .dp-u__media > img'));
    var seen={};
    var images=[];

    sourceImages.forEach(function(img){
      var record=imageRecord(img);
      var key=record.src||record.srcset;
      if(!key)return;
      var imageIndex=seen[key];
      if(typeof imageIndex!=='number'){
        imageIndex=images.length;
        seen[key]=imageIndex;
        images.push(record);
      }
      img.setAttribute('data-dp-sg-index',String(imageIndex));
    });

    if(!images.length)return;
    root.dataset.dpSecondaryGalleryReady='1';

    var titleNode=root.querySelector('.dp-u__title');
    var productTitle=clean(titleNode&&titleNode.textContent)||'Product gallery';
    var lower=root.querySelector('.dp-u__lower');
    var opener=null;
    var currentIndex=0;
    var scrollRaf=0;
    var wheelLocked=false;

    var modal=document.createElement('div');
    modal.className='dp-sg__modal';
    modal.hidden=true;
    modal.setAttribute('aria-hidden','true');
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-label',productTitle+' photo gallery');

    var backdrop=document.createElement('div');
    backdrop.className='dp-sg__backdrop';
    backdrop.setAttribute('data-dp-sg-close','');
    modal.appendChild(backdrop);

    var viewer=document.createElement('div');
    viewer.className='dp-sg__viewer';
    modal.appendChild(viewer);

    var toolbar=document.createElement('div');
    toolbar.className='dp-sg__toolbar';
    viewer.appendChild(toolbar);

    var toolbarInfo=document.createElement('div');
    toolbarInfo.className='dp-sg__toolbar-info';
    var toolbarTitle=document.createElement('strong');
    toolbarTitle.textContent=productTitle;
    var counter=document.createElement('span');
    counter.className='dp-sg__viewer-count';
    counter.setAttribute('aria-live','polite');
    toolbarInfo.appendChild(toolbarTitle);
    toolbarInfo.appendChild(counter);
    toolbar.appendChild(toolbarInfo);

    var closeButton=document.createElement('button');
    closeButton.type='button';
    closeButton.className='dp-sg__close';
    closeButton.setAttribute('data-dp-sg-close','');
    closeButton.setAttribute('aria-label','Close photo gallery');
    closeButton.textContent='×';
    toolbar.appendChild(closeButton);

    var lightbox=document.createElement('div');
    lightbox.className='dp-sg__lightbox';
    viewer.appendChild(lightbox);

    var track=document.createElement('div');
    track.className='dp-sg__track';
    track.setAttribute('tabindex','0');
    track.setAttribute('aria-label','Product photos. Swipe or scroll to browse.');
    lightbox.appendChild(track);

    var slides=[];
    images.forEach(function(record,index){
      var slide=document.createElement('div');
      slide.className='dp-sg__slide';
      slide.dataset.dpSgSlide=String(index);
      slide.setAttribute('role','group');
      slide.setAttribute('aria-label','Photo '+(index+1)+' of '+images.length);
      track.appendChild(slide);
      slides.push(slide);
    });

    var prevButton=document.createElement('button');
    prevButton.type='button';
    prevButton.className='dp-sg__nav dp-sg__nav--prev';
    prevButton.setAttribute('aria-label','Previous photo');
    prevButton.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    lightbox.appendChild(prevButton);

    var nextButton=document.createElement('button');
    nextButton.type='button';
    nextButton.className='dp-sg__nav dp-sg__nav--next';
    nextButton.setAttribute('aria-label','Next photo');
    nextButton.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
    lightbox.appendChild(nextButton);

    document.body.appendChild(modal);

    function hydrate(index,eager){
      if(index<0||index>=images.length)return;
      var slide=slides[index];
      if(!slide||slide.dataset.dpSgHydrated==='1')return;
      slide.dataset.dpSgHydrated='1';
      slide.appendChild(makeImage(images[index],'(max-width: 699px) 100vw, 88vw',!!eager));
    }

    function hydrateAround(index){
      hydrate(index,true);
      hydrate(index-1,false);
      hydrate(index+1,false);
    }

    function updateControls(){
      counter.textContent=(currentIndex+1)+' / '+images.length;
      prevButton.disabled=currentIndex<=0;
      nextButton.disabled=currentIndex>=images.length-1;
      hydrateAround(currentIndex);
    }

    function syncFromScroll(){
      scrollRaf=0;
      var width=track.clientWidth||1;
      var nextIndex=clamp(Math.round(track.scrollLeft/width),0,images.length-1);
      if(nextIndex!==currentIndex){
        currentIndex=nextIndex;
        updateControls();
      }
    }

    function goTo(index,smooth){
      currentIndex=clamp(index,0,images.length-1);
      hydrateAround(currentIndex);
      updateControls();
      var left=currentIndex*(track.clientWidth||0);
      if(smooth&&track.scrollTo){
        track.scrollTo({left:left,behavior:'smooth'});
      }else{
        track.scrollLeft=left;
      }
    }

    function openGallery(index,trigger){
      opener=trigger||null;
      currentIndex=clamp(index,0,images.length-1);
      hydrateAround(currentIndex);
      modal.hidden=false;
      modal.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('dp-sg-open');
      document.body.classList.add('dp-sg-open');
      updateControls();
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          track.scrollLeft=currentIndex*(track.clientWidth||0);
          updateControls();
          closeButton.focus({preventScroll:true});
        });
      });
    }

    function closeGallery(){
      if(modal.hidden)return;
      modal.hidden=true;
      modal.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('dp-sg-open');
      document.body.classList.remove('dp-sg-open');
      if(opener&&opener.focus)opener.focus({preventScroll:true});
      opener=null;
    }

    sourceImages.forEach(function(img){
      var index=parseInt(img.getAttribute('data-dp-sg-index'),10);
      if(isNaN(index))return;
      img.setAttribute('data-dp-sg-open','');
      img.setAttribute('tabindex','0');
      img.setAttribute('role','button');
      img.setAttribute('aria-label','Open photo '+(index+1)+' of '+images.length);
      img.addEventListener('click',function(){openGallery(index,img);});
      img.addEventListener('keydown',function(event){
        if(event.key==='Enter'||event.key===' '){
          event.preventDefault();
          openGallery(index,img);
        }
      });
    });

    if(lower&&images.length>=3){
      var visible=images.slice(1,6);
      var hiddenCount=Math.max(0,images.length-1-visible.length);
      var section=document.createElement('section');
      section.className='dp-sg';
      section.dataset.visible=String(visible.length);
      section.setAttribute('aria-labelledby','dp-sg-title-'+(root.id||'product'));

      var head=document.createElement('div');
      head.className='dp-sg__head';
      var heading=document.createElement('h2');
      heading.id='dp-sg-title-'+(root.id||'product');
      heading.textContent='See Your Plant in Action';
      var photoCount=document.createElement('span');
      photoCount.className='dp-sg__count';
      photoCount.textContent=images.length+' photo'+(images.length===1?'':'s');
      head.appendChild(heading);
      head.appendChild(photoCount);
      section.appendChild(head);

      var mosaic=document.createElement('div');
      mosaic.className='dp-sg__mosaic';
      section.appendChild(mosaic);

      visible.forEach(function(record,index){
        var actualIndex=index+1;
        var button=document.createElement('button');
        button.type='button';
        button.className='dp-sg__tile'+(index===0?' dp-sg__tile--lead':'');
        button.setAttribute('aria-label','Open photo '+(actualIndex+1)+' of '+images.length);
        button.appendChild(makeImage(record,index===0?'(max-width: 699px) calc(100vw - 28px), 50vw':'(max-width: 699px) calc(50vw - 17px), 25vw',false));
        if(index===visible.length-1&&hiddenCount>0){
          var more=document.createElement('span');
          more.className='dp-sg__more';
          var moreTitle=document.createElement('strong');
          moreTitle.textContent='View all';
          var moreCount=document.createElement('small');
          moreCount.textContent='+'+hiddenCount+' more';
          more.appendChild(moreTitle);
          more.appendChild(moreCount);
          button.appendChild(more);
          button.setAttribute('aria-label','Open product gallery. '+images.length+' photos available');
        }
        button.addEventListener('click',function(){openGallery(actualIndex,button);});
        mosaic.appendChild(button);
      });

      lower.parentNode.insertBefore(section,lower);
    }

    prevButton.addEventListener('click',function(){goTo(currentIndex-1,true);});
    nextButton.addEventListener('click',function(){goTo(currentIndex+1,true);});
    track.addEventListener('scroll',function(){
      if(scrollRaf)return;
      scrollRaf=requestAnimationFrame(syncFromScroll);
    },{passive:true});
    track.addEventListener('wheel',function(event){
      if(modal.hidden||Math.abs(event.deltaY)<=Math.abs(event.deltaX))return;
      event.preventDefault();
      if(wheelLocked)return;
      wheelLocked=true;
      goTo(currentIndex+(event.deltaY>0?1:-1),true);
      setTimeout(function(){wheelLocked=false;},320);
    },{passive:false});

    toArray(modal.querySelectorAll('[data-dp-sg-close]')).forEach(function(node){node.addEventListener('click',closeGallery);});
    document.addEventListener('keydown',function(event){
      if(modal.hidden)return;
      if(event.key==='Escape')closeGallery();
      else if(event.key==='ArrowLeft'){event.preventDefault();goTo(currentIndex-1,true);}
      else if(event.key==='ArrowRight'){event.preventDefault();goTo(currentIndex+1,true);}
    });
    window.addEventListener('resize',function(){
      if(modal.hidden)return;
      requestAnimationFrame(function(){track.scrollLeft=currentIndex*(track.clientWidth||0);});
    },{passive:true});
  }

  function boot(){toArray(document.querySelectorAll('[data-dp-unified-product]')).forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

